import { render, staticRenderFns } from "./PostHeader.component.vue?vue&type=template&id=444f0a24&"
import script from "./PostHeader.component.vue?vue&type=script&lang=js&"
export * from "./PostHeader.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports